<template>
  <div
    class="modal fade"
    id="whatsapp-notifications"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="notifications-whatsapp-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("notifications.type.whatsapp") }}</h4>
          </div>
          <div class="text-center">
            <h4 class="mb-8">
              <div class="flex justify-content-center w-100">
                <div>{{ $t("notifications.wa.status") }}:</div>
                <!-- <span
                class="badge me-1"
                :class="{
                  'bg-label-success': this.status === 'open',
                  'bg-label-success': this.status === 'session_connected',
                  'bg-label-warning': this.status == 'session_not_connected',
                  'bg-label-primary': this.status == 'qr',
                  'bg-label-danger': this.status == 'session_not_found',
                  'bg-label-danger': this.status == 'no_instance',
                  'bg-label-success': this.status == 'free',
                }"
                >{{ $t(`notifications.wa.statuses.${this.status}`) }}</span
              > -->
                <div
                  class="badge me-1 bg-label-success"
                  v-if="this.status == 'session_connected'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
                <div
                  class="badge me-1 bg-label-success"
                  v-else-if="this.status == 'open'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
                <div
                  class="badge me-1 bg-label-success"
                  v-else-if="this.status == 'free'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
                <div
                  class="badge me-1 bg-label-warning"
                  v-else-if="this.status == 'session_not_connected'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
                <div
                  class="badge me-1 bg-label-primary"
                  v-else-if="this.status == 'qr'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
                <div
                  class="badge me-1 bg-label-danger"
                  v-else-if="this.status == 'session_not_found'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
                <div
                  class="badge me-1 bg-label-danger"
                  v-else-if="this.status == 'no_instance'"
                >
                  {{ $t(`notifications.wa.statuses.${this.status}`) }}
                </div>
              </div>
            </h4>
            <div class="flex flex-col mb-4">
              <button
                class="btn btn-primary btn-sm mb-2"
                @click.prevent="updateStatus"
              >
                {{ $t("notifications.wa.refresh") }}
              </button>
              <button
                v-if="status == 'session_not_connected'"
                class="btn btn-success btn-sm"
                @click.prevent="restartSession"
              >
                {{ $t("notifications.wa.restart") }}
              </button>
            </div>
          </div>
          <div
            v-if="
              status == 'no_instance' ||
                (status == 'session_not_found' && settings.type == 'local')
            "
            class="col-12 flex flex-col justify-content-center"
          >
            <label>{{ $t("notifications.wa.subscription_key") }}</label>
            <input
              class="form-control text-center"
              dir="ltr"
              placeholder="xxxxxxxx-xxxx-xxxx-xxxxxxxxxxxx"
              v-model="instance.instance"
              type="text"
            />
            <button
              :disabled="loading"
              @click.prevent="instanceCheck"
              class="btn btn-success mt-2"
            >
              {{ $t("notifications.wa.validate") }}
            </button>
            <div v-if="instance_error" class="text-danger">
              * {{ instance_error }}
            </div>
          </div>
          <div class="row g-6 text-center">
            <div
              class="col-12 justify-items-center"
              v-if="qr && this.status == 'qr'"
            >
              <div class="font-bold text-xl">
                {{ $t("notifications.wa.scan_qr") }}
              </div>
              <img :src="`${qr}`" />
            </div>
            <!-- <div class="col-12 d-flex justify-content-end">
              <button class="btn btn-success">Save</button>
            </div> -->
          </div>
          <div class="row border mt-12 gap-y-4 p-4">
            <div class="col-12 col-md-6">
              <label class="form-label d-block">{{
                $t("notifications.config.create_enabled")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    notifications.create_enabled
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="notifications.create_enabled = true"
                >
                  <i class="ti ti-square-check me-1"></i>
                  {{ $t("control.enabled") }}
                </button>
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    !notifications.create_enabled
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="notifications.create_enabled = false"
                >
                  <i class="ti ti-square-x me-1"></i>
                  {{ $t("control.disabled") }}
                </button>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label d-block">{{
                $t("notifications.config.expiring_enabled")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    notifications.expiring_enabled
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="notifications.expiring_enabled = true"
                >
                  <i class="ti ti-square-check me-1"></i>
                  {{ $t("control.enabled") }}
                </button>
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    !notifications.expiring_enabled
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="notifications.expiring_enabled = false"
                >
                  <i class="ti ti-square-x me-1"></i>
                  {{ $t("control.disabled") }}
                </button>
              </div>

              <input
                type="hidden"
                name="auto_backup"
                :value="notifications.expiring_enabled ? 'enabled' : 'disabled'"
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label d-block">{{
                $t("notifications.config.expired_enabled")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    notifications.expired_enabled
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="notifications.expired_enabled = true"
                >
                  <i class="ti ti-square-check me-1"></i>
                  {{ $t("control.enabled") }}
                </button>
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    !notifications.expired_enabled
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="notifications.expired_enabled = false"
                >
                  <i class="ti ti-square-x me-1"></i>
                  {{ $t("control.disabled") }}
                </button>
              </div>

              <input
                type="hidden"
                name="auto_backup"
                :value="notifications.expired_enabled ? 'enabled' : 'disabled'"
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label d-block">{{
                $t("notifications.config.renew_enabled")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    notifications.renew_enabled
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="notifications.renew_enabled = true"
                >
                  <i class="ti ti-square-check me-1"></i>
                  {{ $t("control.enabled") }}
                </button>
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    !notifications.renew_enabled
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="notifications.renew_enabled = false"
                >
                  <i class="ti ti-square-x me-1"></i>
                  {{ $t("control.disabled") }}
                </button>
              </div>

              <input
                type="hidden"
                name="auto_backup"
                :value="notifications.renew_enabled ? 'enabled' : 'disabled'"
              />
            </div>
            <!--- <div class="col-12 col-md-6">
              <label class="form-label d-block">{{
                $t("notifications.config.sham_renew_enabled")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    notifications.sham_renew_enabled
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="notifications.sham_renew_enabled = true"
                >
                  <i class="ti ti-square-check me-1"></i>
                  {{ $t("control.enabled") }}
                </button>
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    !notifications.sham_renew_enabled
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="notifications.sham_renew_enabled = false"
                >
                  <i class="ti ti-square-x me-1"></i>
                  {{ $t("control.disabled") }}
                </button>
              </div>

              <input
                type="hidden"
                name="auto_backup"
                :value="
                  notifications.sham_renew_enabled ? 'enabled' : 'disabled'
                "
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label d-block">{{
                $t("notifications.config.sham_code_enabled")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    notifications.sham_code_enabled
                      ? 'btn-success'
                      : 'btn-outline-success'
                  "
                  @click="notifications.sham_code_enabled = true"
                >
                  <i class="ti ti-square-check me-1"></i>
                  {{ $t("control.enabled") }}
                </button>
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    !notifications.sham_code_enabled
                      ? 'btn-danger'
                      : 'btn-outline-danger'
                  "
                  @click="notifications.sham_code_enabled = false"
                >
                  <i class="ti ti-square-x me-1"></i>
                  {{ $t("control.disabled") }}
                </button>
              </div>

              <input
                type="hidden"
                name="auto_backup"
                :value="
                  notifications.sham_code_enabled ? 'enabled' : 'disabled'
                "
              />
            </div> --->
            <div class="col-12">
              <label class="form-label d-block">{{
                $t("notifications.config.support_number")
              }}</label>
              <input
                type="text"
                class="form-control"
                placeholder="+xxxxxxxxxxx"
                dir="ltr"
                v-model="notifications.support_number"
                :class="{
                  'is-invalid':
                    notifications.support_number != null &&
                    notifications.support_number != '' &&
                    notifications.support_number[0] != '+',
                }"
              />
              <div
                class="invalid-feedback"
                v-if="
                  notifications.support_number != null &&
                    notifications.support_number != '' &&
                    notifications.support_number[0] != '+'
                "
              >
                {{ $t("notifications.config.support_number_invalid") }}
              </div>
            </div>
          </div>
          <div
            class="row border gap-y-4 p-4"
            v-if="hasPrivilege('settings_whatsapp_custom_messages')"
          >
            <div
              class="row"
              v-if="
                notifications.wa_custom_expiration_message_enabled ||
                  notifications.wa_custom_expiring_soon_message_enabled ||
                  notifications.wa_custom_renew_message_enabled ||
                  notifications.wa_custom_sham_renew_message_enabled
              "
            >
              <div class="col-12">
                <h5>{{ $t("notifications.config.available_variables") }}</h5>
                <p class="text-muted">
                  {{ $t("notifications.config.variables_note") }}
                </p>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.username")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{username}"
                    type="text"
                    class="form-control"
                    disabled
                    id="username-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('username-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.fullname")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{full_name}"
                    type="text"
                    class="form-control"
                    disabled
                    id="fullname-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('fullname-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.profile_name")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{profile}"
                    type="text"
                    class="form-control"
                    disabled
                    id="profile-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('profile-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.profile_price")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{price}"
                    type="text"
                    class="form-control"
                    disabled
                    id="price-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('price-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.paid_amount")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{paid_amount}"
                    type="text"
                    class="form-control"
                    disabled
                    id="paid-amount-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('paid-amount-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.debt")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{debt}"
                    type="text"
                    class="form-control"
                    disabled
                    id="debt-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('debt-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.discount")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{discount}"
                    type="text"
                    class="form-control"
                    disabled
                    id="discount-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('discount-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.total_debts")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{total_debt}"
                    type="text"
                    class="form-control"
                    disabled
                    id="total-debts-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('total-debts-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.invoice_number")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{invoice_number}"
                    type="text"
                    class="form-control"
                    disabled
                    id="invoice-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('invoice-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.sham_cash_code")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{shamcode}"
                    type="text"
                    class="form-control"
                    disabled
                    id="shamcode-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('shamcode-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.expires_at")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{expires_at}"
                    type="text"
                    class="form-control"
                    disabled
                    id="expires-at-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('expires-at-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{
                  $t("notifications.config.network_name")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    value="{network_name}"
                    type="text"
                    class="form-control"
                    disabled
                    id="network-name-input"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="copyToClip('network-name-input')"
                  >
                    <i class="ti ti-copy ti-s "></i>
                  </button>
                </div>
              </div>
              <div>
                {{
                  $t("notifications.config.do_not_put_links_inside_the_message")
                }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.wa_custom_expiration_message_enabled"
                />
                {{ $t("notifications.config.custom_expiration_message") }}
              </label>
              <textarea
                v-if="notifications.wa_custom_expiration_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.wa_custom_expiration_message"
                :class="{ 'is-invalid': errors.custom_expiration_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.wa_custom_expiration_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_expiration_length }"
              >
                255/{{ notifications.wa_custom_expiration_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.wa_custom_renew_message_enabled"
                />
                {{ $t("notifications.config.custom_renew_message") }}
              </label>
              <textarea
                v-if="notifications.wa_custom_renew_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.wa_custom_renew_message"
                :class="{ 'is-invalid': errors.custom_renew_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.wa_custom_renew_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_renew_length }"
              >
                255/{{ notifications.wa_custom_renew_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="
                    notifications.wa_custom_expiring_soon_message_enabled
                  "
                />
                {{ $t("notifications.config.custom_expiring_soon_message") }}
              </label>
              <textarea
                v-if="notifications.wa_custom_expiring_soon_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.wa_custom_expiring_soon_message"
                :class="{ 'is-invalid': errors.custom_expiring_soon_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.wa_custom_expiring_soon_message_enabled"
                class="text-end text-muted"
                :class="{
                  'invalid-feedback': errors.custom_expiring_soon_length,
                }"
              >
                255/{{ notifications.wa_custom_expiring_soon_message.length }}
              </div>
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  v-model="notifications.wa_custom_sham_renew_message_enabled"
                />
                {{ $t("notifications.config.custom_sham_renew_message") }}
              </label>
              <textarea
                v-if="notifications.wa_custom_sham_renew_message_enabled"
                class="form-control mt-2"
                rows="3"
                v-model="notifications.wa_custom_sham_renew_message"
                :class="{ 'is-invalid': errors.custom_sham_renew_length }"
                @input="validate"
              ></textarea>
              <div
                v-if="notifications.wa_custom_sham_renew_message_enabled"
                class="text-end text-muted"
                :class="{ 'invalid-feedback': errors.custom_sham_renew_length }"
              >
                255/{{ notifications.wa_custom_sham_renew_message.length }}
              </div>
            </div>
          </div>
          <div class="row mt-6">
            <div class="col-12 text-center">
              <button
                class="btn btn-primary"
                @click.prevent="store"
                :disabled="
                  (notifications.support_number != null &&
                    notifications.support_number != '' &&
                    notifications.support_number[0] != '+') ||
                    !validated ||
                    loading
                "
              >
                {{ $t("control.save") }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="status != 'no_instance'" class="row g-6 text-end mt-2">
          <button class="dropdown-item text-danger" @click.prevent="deleteWa">
            <i class="ti ti-trash me-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
import { hasPrivilege } from "../../global_constants";

export default {
  name: "notificationsWhatsapp",
  data() {
    return {
      qr: null,
      loading: false,
      status: "",
      notifications: {
        expired: "قم بتجديد الاشتراك لاستعادة الاتصال بالانترنت",
        expiring: "قم بتجديد الاشتراك كي لا تفقد الاتصال بالانترنت",
        renew: "شكرا لك على استخدامك شبكتنا",
        renew_enabled: false,
        expired_enabled: false,
        expiring_enabled: false,
        create_enabled: false,
        sham_code_enabled: false,
        sham_renew_enabled: false,
        support_number: null,
        wa_custom_expiration_message: "",
        wa_custom_expiration_message_enabled: false,
        wa_custom_expiring_soon_message: "",
        wa_custom_expiring_soon_message_enabled: false,
        wa_custom_renew_message: "",
        wa_custom_renew_message_enabled: false,
        wa_custom_sham_renew_message: "",
        wa_custom_sham_renew_message_enabled: false,
      },
      instance: {
        instance: "",
      },
      instance_error: null,
      validated: true,
      errors: {
        expired: null,
        expiring: null,
        custom_expiration_length: null,
        custom_expiring_soon_length: null,
        custom_renew_length: null,
        custom_sham_renew_length: null,
        renew: null,
      },
      inside_page: true,
      showDeleteWa: false,
      text_direction:
        this.$i18n.locale == "ar" ? "direction:rtl" : "direction:ltr",
      qr_interval: null,
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },

  async created() {
    this.statusCheck();
    this.getQr();
    this.fetchSettings();
    this.qr_interval = setInterval(() => {
      if (this.status == "qr") this.getQr();
    }, 30000);
    // while (this.inside_page) {
    //   if (this.status == "qr") this.getQr();
    //   await new Promise((r) => setTimeout(r, 30000));
    // }
  },
  unmounted() {
    clearInterval(this.qr_interval);
    this.qr_interval = null;
    this.inside_page = false;
  },
  watch: {
    $route(to, from) {
      clearInterval(this.qr_interval);
      this.qr_interval = null;
      this.inside_page = false;
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async getQr() {
      // this.loading = true;
      var res = await axios.get("wa/qr");
      if (res.status == 200) {
        this.qr = res.data.qr_code;
      }
      // this.loading = false;
    },
    async statusCheck() {
      var response = await axios.get("wa/status");
      if (response.status == 200) {
        if (response.data.status == "open") this.status = "session_connected";
        else if (response.data.status == "session_not_connected")
          this.status = "session_not_connected";
        else this.status = "qr";
        if (this.status == "browser tab closed")
          this.status = "session_not_found";
      } else if (response.status == 210) {
        this.status = "no_instance";
      }
      console.log(this.status);

      //this.status = "no_instance";
    },
    async restartSession() {
      var response = await axios.post("wa/restart");
      if (response.status == 200) {
        this.$swal({
          title: this.$t("notifications.wa.session_restarted"),
          icon: "success",
        });
        this.statusCheck();
      } else if (response.status == 210) {
        this.$swal({
          title: this.$t("notifications.wa.session_restart_failed"),
          icon: "error",
        });
      }
      console.log(this.status);

      //this.status = "no_instance";
    },
    async deleteWa() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "notifications.this_will_delete_whatsapp_key_and_disconnect_it",
        ),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            var response = await axios.post("wa/clear");

            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("notifications.whatsapp_key_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
            if (response.status == 200) {
              location.reload();
            }
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async fetchSettings() {
      this.loading = true;
      const response = await axios.get("wa/notifications");
      if (response.status == 200) {
        var temp = response.data.data;
        temp.forEach((element) => {
          switch (element.key) {
            case "wa_notifications_expiring_enabled":
              this.notifications.expiring_enabled = element.value == 1;
              break;
            case "wa_notifications_expiring_body":
              this.notifications.expiring = element.value;
              break;
            case "wa_notifications_expired_enabled":
              this.notifications.expired_enabled = element.value == 1;
              break;
            case "wa_notifications_expired_body":
              this.notifications.expired = element.value;
              break;
            case "wa_notifications_renew_enabled":
              this.notifications.renew_enabled = element.value == 1;
              break;
            case "wa_notifications_renew_body":
              this.notifications.renew = element.value;
              break;
            case "wa_notifications_create_enabled":
              this.notifications.create_enabled = element.value == 1;
              break;
            case "wa_notifications_support_number":
              this.notifications.support_number = element.value;
              break;
            case "wa_notifications_sham_code_enabled":
              this.notifications.sham_code_enabled = element.value == 1;
              break;
            case "wa_notifications_sham_renew_enabled":
              this.notifications.sham_renew_enabled = element.value == 1;
              break;
            case "wa_notifications_custom_expiration_message":
              this.notifications.wa_custom_expiration_message = element.value;
              if (element.value != null)
                this.notifications.wa_custom_expiration_message_enabled = true;
              break;
            case "wa_notifications_custom_renew_message":
              this.notifications.wa_custom_renew_message = element.value;
              if (element.value != null)
                this.notifications.wa_custom_renew_message_enabled = true;
              break;
            case "wa_notifications_custom_expiring_soon_message":
              this.notifications.wa_custom_expiring_soon_message =
                element.value;
              if (element.value != null)
                this.notifications.wa_custom_expiring_soon_message_enabled = true;
              break;
            case "wa_notifications_custom_sham_renew_message":
              this.notifications.wa_custom_sham_renew_message = element.value;
              if (element.value != null)
                this.notifications.wa_custom_sham_renew_message_enabled = true;
              break;
            default:
              break;
          }
        });
      }
      this.loading = false;
    },
    async store() {
      this.loading = true;
      const response = await axios.post("wa/notifications", this.notifications);
      if (response.status == 200) {
        this.$notify({
          text: this.$t("messages.whatsapp_settings_updated_successfully"),
          type: "success",
        });
      }
      this.loading = false;
    },
    async instanceCheck() {
      this.loading = true;
      const response = await axios.post("wa/instance", this.instance);
      if (response.status == 200) {
        this.$swal({
          title: this.$t("notifications.wa.license_validated"),
          icon: "success",
        });
        location.reload();
      } else if (response.status == 210) {
        this.instance_error = this.$t(
          `errors.notifications.wa.license_not_valid`,
        );
      }
      this.loading = false;
    },
    async updateStatus() {
      this.statusCheck();
      // if (this.status == "session_not_connected") this.getQr();
    },
    copyToClip(id) {
      // Get the text field
      var copyText = document.getElementById(id);

      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
    validate() {
      this.validated = true;
      this.errors.expired = null;
      this.errors.expiring = null;
      this.errors.renew = null;
      this.errors.custom_expiration_length = null;
      this.errors.custom_expiring_soon_length = null;
      this.errors.custom_renew_length = null;
      this.errors.custom_sham_renew_length = null;
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      if (
        this.notifications.expired.includes(".") ||
        this.notifications.expired.includes("http")
      ) {
        this.errors.expired = this.$t("errors.notifications.wa.url");
        this.validated = false;
      }
      if (
        this.notifications.expiring.includes(".") ||
        this.notifications.expiring.includes("http")
      ) {
        this.errors.expiring = this.$t("errors.notifications.wa.url");
        this.validated = false;
      }
      if (
        this.notifications.renew.includes(".") ||
        this.notifications.renew.includes("http")
      ) {
        this.errors.renew = this.$t("errors.notifications.wa.url");
        this.validated = false;
      }
      if (
        this.notifications.wa_custom_expiration_message_enabled &&
        this.notifications.wa_custom_expiration_message.length > 255
      ) {
        this.errors.custom_expiration_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.wa_custom_expiring_soon_message_enabled &&
        this.notifications.wa_custom_expiring_soon_message.length > 255
      ) {
        this.errors.custom_expiring_soon_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.wa_custom_renew_message_enabled &&
        this.notifications.wa_custom_renew_message.length > 255
      ) {
        this.errors.custom_renew_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
      if (
        this.notifications.wa_custom_sham_renew_message_enabled &&
        this.notifications.wa_custom_sham_renew_message.length > 255
      ) {
        this.errors.custom_sham_renew_length = this.$t(
          "errors.notifications.wa.custom_message_length",
        );
        this.validated = false;
      }
    },
  },
  components: { QrcodeVue },
};
</script>
